export default "__VITE_ASSET__2MaV1qre__"